<div class="d-flex justify-content-center w-100 align-items-center spinner" *ngIf="!isConnectedToRemoteMachine">
  <app-loader></app-loader>
</div>

<canvas [id]="monitorKey?.MonitorHandler" #canvas (click)="onCanvasClick($event)" [ngClass]="{'hidden': !isConnectedToRemoteMachine}"
  (dblclick)="onCanvasDoubleClick($event)"></canvas>

<mat-icon class="close-button" *ngIf="isConnectedToRemoteMachine" (click)="closeRemoteControlWindow()" svgIcon="cancel"
  matTooltip="Close remote control stream"></mat-icon>
